/* eslint-disable array-callback-return */
import { Component } from "react";
import HeaderWithBanner from "../../components/header/HeaderWithBanner";
import Footer from '../../components/footer/Footer';
import { imsLoader, saveBlueIcon, printBlueIcon, emailBlueIcon, downloadBlueIcon, saveWhiteIcon, printWhiteIcon, emailWhiteIcon, downloadWhiteIcon, backToAllResults, collapseAllIcon, deleteIcon, leftArrowWhite, collapseAllIconWhite, deleteWhite } from '../../assets'
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import NavigationMenu from "../../components/Navigation/NavigationMenu";
import MIAsRefGlobalSearchFeaturePopUpModal from "../../components/PopUp/MIAsRefGlobalSearchFeaturesPopUpModal";
import MIAsReferencesDocumentCard from "../DocumentResults/MIAsReferencesDocumentCard";
import Services from "../../utils/services";
import './ViewSelectedResults.css';

class ViewSelectedResultsMIAsReferences extends Component {
    userid;
    userExists;
    documentsUrl = [];
    markedDocumentsUrl = [];
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            userExists: false,
            width: window.innerWidth,
            height: window.innerHeight,
            selectedCitation: [],
            documentIndex: [],
            itemTeaser: [],
            showSaveModal: false,
            showPrintModal: false,
            showEmailModal: false,
            showDownloadModal: false,
            showGSFModal: false,
            citationSelectStatus: [],
            selectedResults: [],
            isCollapseAll: false,
            collapsedAll: [],
            displayedResults: []
        }
    }
    componentDidMount() {
        document.title = 'iMedical Search: View Marked Results';
        this.userid = JSON.parse(localStorage.getItem('username'));
        this.userExists = localStorage.getItem('userExists');
        let service = new Services();
        service.logService(`View selectes page successfully mounted for ${this.userid.toLowerCase()}`, 'info')
        let citationSelectStatus = [];
        let selectedCitation = [];
        let documentIndex = [];
        let itemTeaser = [];
        let selectedResults = [];
        let collapsedAll = [];
        if (this.userExists) {
            this.setState({
                userExists: this.userExists
            })
            if (this.props.location.state?.selectedResults !== undefined) {
                localStorage.getItem('selectedResults').split(',').map((x, i) => {
                    selectedCitation.push(this.props.location.state.selectedResults[i].detail);
                    documentIndex.push(this.props.location.state.selectedResults[i].index);
                    itemTeaser.push(this.props.location.state.selectedResults[i].itemTeaser);
                    selectedResults.push(this.props.location.state.selectedResults[i]);
                    citationSelectStatus.push(true);
                    this.markedDocumentsUrl = JSON.parse(localStorage.getItem('markedResultsUrl'))
                    this.setState({
                        selectedCitation: selectedCitation,
                        documentIndex: documentIndex,
                        itemTeaser: itemTeaser,
                        selectedResults: selectedResults,
                        citationSelectStatus: citationSelectStatus
                    })
                })
            }
            for (let index = 0; index < this.props.location.state.selectedResults.length; index++) {
                collapsedAll.push(false)
            }
            this.setState({ collapsedAll: collapsedAll })
            window.addEventListener('resize', this.updateDimensions);
        }
        else {
            console.log('Access Denied');
            this.props.history.push('/');
        }
        // let citationSelectStatus = [];
        // // console.log(localStorage.getItem('selectedResults'),this.props.location.state.selectedResults.map(x => x.index))
        // // let data = this.state.selectedResults;
        // let selectedCitation = [];
        // let documentIndex = [];
        // let itemTeaser = [];
        // let selectedResults = [];
        // if (this.props.location.state?.selectedResults !== undefined) {
        //     localStorage.getItem('selectedResults').split(',').map((x, i) => {
        //         selectedCitation.push(this.props.location.state.selectedResults[i].detail);
        //         documentIndex.push(this.props.location.state.selectedResults[i].index);
        //         itemTeaser.push(this.props.location.state.selectedResults[i].itemTeaser);
        //         selectedResults.push(this.props.location.state.selectedResults[i]);
        //         citationSelectStatus.push(true)
        //         this.setState({
        //             selectedCitation: selectedCitation,
        //             documentIndex: documentIndex,
        //             itemTeaser: itemTeaser,
        //             selectedResults: selectedResults,
        //             citationSelectStatus: citationSelectStatus
        //         }/* , () => {
        //                     for (let index = 0; index < this.state.selectedCitation.length; index++) {
        //                         citationSelectStatus.push(true)
        //                     }
        //                     this.setState({ citationSelectStatus: citationSelectStatus })
        //                 } */)
        //     })
        // }
        // let collapsedAll = [];
        // for (let index = 0; index < this.props.location.state.selectedResults.length; index++) {
        //     collapsedAll.push(false)
        // }
        // this.setState({ collapsedAll: collapsedAll })
    }
    // componentWillReceiveProps() {
    //     let citationSelectStatus = [];
    //     if (this.props.location.state?.selectedResults !== undefined) {
    //         // console.log(this.props.location.state.selectedResults)
    //         this.setState({
    //             selectedCitation: this.props.location.state.selectedResults.map(x => x.detail),
    //             documentIndex: this.props.location.state.selectedResults.map(x => x.index),
    //             itemTeaser: this.props.location.state.selectedResults.map(x => x.itemTeaser)
    //         }, () => {
    //             for (let index = 0; index < this.state.selectedCitation.length; index++) {
    //                 citationSelectStatus.push(true)
    //             }
    //             this.setState({ citationSelectStatus: citationSelectStatus })
    //         })
    //     }
    //     // console.log(this.state.selectedResults)
    // }
    // componentDidUpdate = (previousProps) => {
    //     // console.log(this.state.selectedResults,previousProps)
    //     let citationSelectStatus = [];
    //     if (this.state.selectedResults.length > 0 && this.state.selectedResults.length !== this.props.location.state.selectedResults.length) {
    //         this.setState({
    //             selectedCitation: this.state.selectedResults.map(x => x.detail),
    //             documentIndex: this.state.selectedResults.map(x => x.index),
    //             itemTeaser: this.state.selectedResults.map(x => x.itemTeaser)
    //         }, () => {
    //             for (let index = 0; index < this.state.selectedCitation.length; index++) {
    //                 citationSelectStatus.push(true)
    //             }
    //             this.setState({ citationSelectStatus: citationSelectStatus })
    //         })
    //     }
    // }
    componentWillUnmount() {
        let service = new Services();
        service.logService(`View selected page successfully unmounted for ${this.userid.toLowerCase()}`, 'info')
        window.removeEventListener('resize', this.updateDimensions);
    }
    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight })
    }
    generateDocumentTeaser = (teaserData) => {
        let str = ''
        if (teaserData.length > 0) {
            teaserData.map((item, index) => {
                str += item + "..."
            })
        }
        //console.log(str)
        //console.log(this.convertToHtml(str))
        return str;
    }
    handleCitationSelection = (index, item, itemTeaser, key) => {
        // console.log(index, item, itemTeaser,key,this.state.citationSelectStatus)
        let a = this.state.citationSelectStatus;
        a[key] = !this.state.citationSelectStatus[key];
        // a[index - 1] = !this.state.citationSelectStatus[index - 1];
        let data = this.state.selectedResults;
        // let data = this.props.location.state.selectedResults;
        let urls = this.markedDocumentsUrl;
        if (this.state.citationSelectStatus[key]) {
            data.push({
                detail: item,
                itemTeaser: itemTeaser,
                index: index
            })
            urls.push(this.documentsUrl[key])
        }
        else {
            const i = data.map(x => (x.index)).indexOf(index);
            if (i > -1) {
                data.splice(i, 1); // 2nd parameter means remove one item only
                urls.splice(i, 1);
            }
            // data.splice(index - 1, 1)
        }
        // let selectedResultsDetails = this.state.selectedResults;
        sessionStorage.setItem("selectedResultsDetails", JSON.stringify(data));
        let selectedResultsIndex = data.map(x => x.index)
        localStorage.setItem('selectedResults', selectedResultsIndex)
        localStorage.setItem('markedResultsUrl', JSON.stringify(urls))
        this.markedDocumentsUrl = urls;
        // console.log(data,a)
        this.setState({
            citationSelectStatus: a,
            selectedResults: data,
        })
    }
    citationUrl = (url, index, item) => {
        let a = this.documentsUrl;
        if (item.domain === "CTGov") {
            a[index] = url;
        }
        else {
            a[index] = window.location.origin + url;
            // a[index] = "https://predev-ims.jnj.com" + url;
        }
        this.documentsUrl = a;
    }
    convertToHtml = (item) => {
        return (<div dangerouslySetInnerHTML={{ __html: item }}></div>)
    }
    selectedResults = (results, itemTeaser, documentIndex) => {
        let displayedResults = []
        if (results?.length > 0) {
            return (
                <>
                    {results.map((details, index) => {
                        // if (itemTeaser[index].length <= 0) {
                        if (itemTeaser[index] === undefined) {
                            displayedResults.push({
                                detail: details,
                                itemTeaser: [],
                                // index: index+1
                                index: documentIndex[index],
                            })
                        }
                        else {
                            displayedResults.push({
                                detail: details,
                                itemTeaser: itemTeaser[index],
                                // index: index+1
                                index: documentIndex[index],
                            })
                        }
                        return (
                            <>
                                <div key={`result-id-${index}`} id={`result-id-${index}`}>
                                    {
                                        <div className="resultDetailsDiv">
                                            <MIAsReferencesDocumentCard item={details} count={documentIndex[index]} /* itemTeaser={itemTeaser[index].length <= 0 ? [] : itemTeaser[index]} */ itemTeaser={itemTeaser[index] === undefined ? [] : itemTeaser[index]} handleCitationSelection={(i, item, itemTeaser, key) => this.handleCitationSelection(i, item, itemTeaser, index)} isChecked={this.state.citationSelectStatus[index]} /* isCollapseAll={this.state.isCollapseAll} */ collapsedAll={this.state.collapsedAll} customWidth={this.state.width} handlecollapsed={() => this.handlecollapsed(index)} resultsIndex={index} citationUrl={(url) => this.citationUrl(url, index, details)} />
                                            <div className="resultsDivFooter">
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                        )
                    })}
                    {localStorage.setItem('displayedResults', JSON.stringify(displayedResults))}
                </>
            )
        }
    }
    handleBackToResult = () => {
        this.props.history.goBack();
    }
    handlecollapsed = (index) => {
        let collapsedAll = this.state.collapsedAll;
        collapsedAll[index] = !this.state.collapsedAll[index];
        // console.log(collapsedAll)
        this.setState({ collapsedAll: collapsedAll })
        if (collapsedAll.every((val, i, arr) => val === true/* arr[0] */)) {
            this.setState({ isCollapseAll: true })
        }
        else {
            this.setState({ isCollapseAll: false })
        }
    }
    handleCollapseAll = () => {
        let collapsedAll = this.state.collapsedAll;
        // let data = this.props.location.state.selectedResults;
        for (let index = 0; index < collapsedAll.length; index++) {
            // collapsedAll[index] = !this.state.collapsedAll[index];
            if (this.state.isCollapseAll) {
                collapsedAll[index] = false
            }
            else {
                collapsedAll[index] = true
            }

            if (collapsedAll[index]) {
                this.setState({ isCollapseAll: true })
            }
            else {
                this.setState({ isCollapseAll: false })
            }
        }
        this.setState({ collapsedAll: collapsedAll })
        // this.setState({ isCollapseAll: !this.state.isCollapseAll })
    }
    handleClearSelection = () => {
        localStorage.removeItem('selectedResults')
        localStorage.removeItem('markedResultsUrl')
        sessionStorage.clear();
        this.markedDocumentsUrl = [];
        this.documentsUrl = [];
        this.setState({ citationSelectStatus: [], selectedResults: [] })
    }
    componentDidUpdate() {
        // console.log(this.state,"xx", this.props)
    }
    render() {
        return (
            <div>
                <ErrorBoundary>
                    {this.state.userExists ? <>
                        <NavigationMenu pathName={window.location.pathname} customWidth={this.state.width} customHeight={this.state.height} />
                        <div className="header-wrapper">
                            {this.state.width > 600 && <HeaderWithBanner />}
                        </div>
                        {
                            this.state.width < 600 ?
                                <div className="view-selected-top-bottom-container-mobile">
                                    {/* <div className="links-container"> */}
                                    <div className="features-buttons-mobile" onClick={this.handleBackToResult}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 17.014 17.014">
                                            <path id="Path_17624" data-name="Path 17624" d="M12.507,4l1.5,1.5L8.073,11.443H21.014V13.57H8.073l5.934,5.944-1.5,1.5L4,12.507Z" transform="translate(-4 -4)" fill="currentColor" />
                                        </svg>
                                        <span>Back to All Results</span>
                                    </div>
                                    <div className="features-buttons-mobile" onClick={this.handleCollapseAll}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14.763" height="14.763" viewBox="0 0 14.763 14.763">
                                            <path id="Path_17625" data-name="Path 17625" d="M17.763,9.561V3H11.2l2.7,2.7L5.7,13.9,3,11.2v6.561H9.561l-2.7-2.7,8.2-8.2Z" transform="translate(-3 -3)" fill="currentColor" />
                                        </svg>
                                        <span>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                                    </div>
                                    <div className="features-buttons-mobile" onClick={this.handleClearSelection}>
                                        <svg id="delete" xmlns="http://www.w3.org/2000/svg" width="11.274" height="16.156" viewBox="0 0 11.274 16.156">
                                            <g id="Group_23297" data-name="Group 23297" transform="translate(0)">
                                                <g id="Group_23296" data-name="Group 23296" transform="translate(0)">
                                                    <path id="Path_11289" data-name="Path 11289" d="M64,95a1.61,1.61,0,0,0,1.611,1.611h6.443A1.61,1.61,0,0,0,73.664,95V85.333H64Z" transform="translate(-63.195 -81.201)" fill="none" stroke="currentColor" stroke-width="1.5" />
                                                    <path id="Path_11290" data-name="Path 11290" d="M51.123.805,50.317,0H46.291l-.805.805H42.667V2.416H53.941V.805Z" transform="translate(-42.667)" fill="currentColor" />
                                                </g>
                                            </g>
                                        </svg>
                                        <span>Clear Selection</span>
                                    </div>
                                    {/* <span className="vs-links" onClick={this.handleCollapseAll}>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                                <div className="links-sepration-blue"></div>
                                <Link className="vs-links" onClick={this.handleBackToResult}>Back to All Results</Link>
                                <div className="links-sepration-blue"></div>
                                <Link className="vs-links" onClick={this.handleClearSelection}>Clear Selection</Link> */}
                                    {/* </div>
                                    <div className="links-sepration-blue"></div>
                                    <div className="buttons-container"> */}
                                    {/* <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showSaveModal: true, showPrintModal: false, showEmailModal: false, showDownloadModal: false }) }} >
                                            <img src={saveBlueIcon} alt="save-icon" width={17} height={17} className="vs-img" //onMouseOver={e=>(e.currentTarget.src=saveWhiteIcon)} onMouseOut={e=>(e.currentTarget.src=saveBlueIcon)} />
                                            <img src={saveWhiteIcon} alt="save-icon" width={17} height={17} className="vs-img-hov" />
                                            <span>Save</span>
                                        </div> 
                                        <div className="features-buttons"  //onClick={(e) => { this.setState({ showGSFModal: true, showPrintModal: true, showSaveModal: false, showEmailModal: false, showDownloadModal: false }) }} >
                                            <img src={printBlueIcon} alt="print-icon" width={15} height={15} className="vs-img" />
                                            <img src={printWhiteIcon} alt="save-icon" width={15} height={15} className="vs-img-hov" />
                                            <span>Print</span>
                                        </div> */}
                                    <div className="features-buttons-mobile" onClick={(e) => { this.setState({ showGSFModal: true, showEmailModal: true, showSaveModal: false, showPrintModal: false, showDownloadModal: false }) }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20.519" height="20.519" viewBox="0 0 30.519 30.519">
                                            <g id="mark_email_read_black_18dp" transform="translate(0.15 0.15)">
                                                <rect id="Rectangle_7959" data-name="Rectangle 7959" width="20" height="20" transform="translate(-0.15 -0.15)" fill="none" />
                                                <path id="Path_16756" data-name="Path 16756" d="M13.559,19.688H5.2V9.24l8.363,5.022L22.04,9.24v6.11h2.077V5.508A1.513,1.513,0,0,0,22.609,4H4.508A1.513,1.513,0,0,0,3,5.508V20.592A1.513,1.513,0,0,0,4.508,22.1h9.05Zm9.05-13.317-9.05,4.9L5.2,6.371ZM19.23,23.609l-4.65-4.195,1.071-1.071,3.579,3.124,8.325-8.292,1.056,1.086Z" transform="translate(1.551 2.06)" fill="currentColor" />
                                            </g>
                                        </svg>
                                        <span>Email</span>
                                    </div>
                                    {/* <div className="features-buttons" //onClick={(e) => { this.setState({ showGSFModal: true, showDownloadModal: true, showSaveModal: false, showPrintModal: false, showEmailModal: false }) }}>
                                            <img src={downloadBlueIcon} alt="download-icon" width={18} height={18} className="vs-img" />
                                            <img src={downloadWhiteIcon} alt="save-icon" width={18} height={18} className="vs-img-hov" />
                                            <span>Download</span>
                                        </div> */}
                                    {/* </div> */}
                                </div>
                                :
                                this.state.width < 1000 ?
                                    <div className="view-selected-top-bottom-container">
                                        {/* <div className="links-container"> */}
                                        <div className="features-buttons" onClick={this.handleBackToResult}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 17.014 17.014">
                                                <path id="Path_17624" data-name="Path 17624" d="M12.507,4l1.5,1.5L8.073,11.443H21.014V13.57H8.073l5.934,5.944-1.5,1.5L4,12.507Z" transform="translate(-4 -4)" fill="currentColor" />
                                            </svg>
                                            <span>Back to All Results</span>
                                        </div>
                                        <div className="features-buttons" onClick={this.handleCollapseAll}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.763" height="14.763" viewBox="0 0 14.763 14.763">
                                                <path id="Path_17625" data-name="Path 17625" d="M17.763,9.561V3H11.2l2.7,2.7L5.7,13.9,3,11.2v6.561H9.561l-2.7-2.7,8.2-8.2Z" transform="translate(-3 -3)" fill="currentColor" />
                                            </svg>
                                            <span>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                                        </div>
                                        <div className="features-buttons" onClick={this.handleClearSelection}>
                                            <svg id="delete" xmlns="http://www.w3.org/2000/svg" width="11.274" height="16.156" viewBox="0 0 11.274 16.156">
                                                <g id="Group_23297" data-name="Group 23297" transform="translate(0)">
                                                    <g id="Group_23296" data-name="Group 23296" transform="translate(0)">
                                                        <path id="Path_11289" data-name="Path 11289" d="M64,95a1.61,1.61,0,0,0,1.611,1.611h6.443A1.61,1.61,0,0,0,73.664,95V85.333H64Z" transform="translate(-63.195 -81.201)" fill="none" stroke="currentColor" stroke-width="1.5" />
                                                        <path id="Path_11290" data-name="Path 11290" d="M51.123.805,50.317,0H46.291l-.805.805H42.667V2.416H53.941V.805Z" transform="translate(-42.667)" fill="currentColor" />
                                                    </g>
                                                </g>
                                            </svg>
                                            <span>Clear Selection</span>
                                        </div>
                                        {/* <span className="vs-links" onClick={this.handleCollapseAll}>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                                <div className="links-sepration-blue"></div>
                                <Link className="vs-links" onClick={this.handleBackToResult}>Back to All Results</Link>
                                <div className="links-sepration-blue"></div>
                                <Link className="vs-links" onClick={this.handleClearSelection}>Clear Selection</Link> */}
                                        {/* </div>
                                    <div className="links-sepration-blue"></div>
                                    <div className="buttons-container"> */}
                                        {/* <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showSaveModal: true, showPrintModal: false, showEmailModal: false, showDownloadModal: false }) }} >
                                            <img src={saveBlueIcon} alt="save-icon" width={17} height={17} className="vs-img" //onMouseOver={e=>(e.currentTarget.src=saveWhiteIcon)} onMouseOut={e=>(e.currentTarget.src=saveBlueIcon)} />
                                            <img src={saveWhiteIcon} alt="save-icon" width={17} height={17} className="vs-img-hov" />
                                            <span>Save</span>
                                        </div> 
                                        <div className="features-buttons"  //onClick={(e) => { this.setState({ showGSFModal: true, showPrintModal: true, showSaveModal: false, showEmailModal: false, showDownloadModal: false }) }} >
                                            <img src={printBlueIcon} alt="print-icon" width={15} height={15} className="vs-img" />
                                            <img src={printWhiteIcon} alt="save-icon" width={15} height={15} className="vs-img-hov" />
                                            <span>Print</span>
                                        </div> */}
                                        <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showEmailModal: true, showSaveModal: false, showPrintModal: false, showDownloadModal: false }) }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20.519" height="20.519" viewBox="0 0 30.519 30.519">
                                                <g id="mark_email_read_black_18dp" transform="translate(0.15 0.15)">
                                                    <rect id="Rectangle_7959" data-name="Rectangle 7959" width="20" height="20" transform="translate(-0.15 -0.15)" fill="none" />
                                                    <path id="Path_16756" data-name="Path 16756" d="M13.559,19.688H5.2V9.24l8.363,5.022L22.04,9.24v6.11h2.077V5.508A1.513,1.513,0,0,0,22.609,4H4.508A1.513,1.513,0,0,0,3,5.508V20.592A1.513,1.513,0,0,0,4.508,22.1h9.05Zm9.05-13.317-9.05,4.9L5.2,6.371ZM19.23,23.609l-4.65-4.195,1.071-1.071,3.579,3.124,8.325-8.292,1.056,1.086Z" transform="translate(1.551 2.06)" fill="currentColor" />
                                                </g>
                                            </svg>
                                            <span>Email</span>
                                        </div>
                                        {/* <div className="features-buttons" //onClick={(e) => { this.setState({ showGSFModal: true, showDownloadModal: true, showSaveModal: false, showPrintModal: false, showEmailModal: false }) }}>
                                            <img src={downloadBlueIcon} alt="download-icon" width={18} height={18} className="vs-img" />
                                            <img src={downloadWhiteIcon} alt="save-icon" width={18} height={18} className="vs-img-hov" />
                                            <span>Download</span>
                                        </div> */}
                                        {/* </div> */}
                                    </div>
                                    :
                                    <div className="view-selected-top-bottom-container">
                                        <div className="links-container">
                                            <div className="features-buttons" onClick={this.handleBackToResult}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 17.014 17.014">
                                                    <path id="Path_17624" data-name="Path 17624" d="M12.507,4l1.5,1.5L8.073,11.443H21.014V13.57H8.073l5.934,5.944-1.5,1.5L4,12.507Z" transform="translate(-4 -4)" fill="currentColor" />
                                                </svg>
                                                <span>Back to All Results</span>
                                            </div>
                                            <div className="features-buttons" onClick={this.handleCollapseAll}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14.763" height="14.763" viewBox="0 0 14.763 14.763">
                                                    <path id="Path_17625" data-name="Path 17625" d="M17.763,9.561V3H11.2l2.7,2.7L5.7,13.9,3,11.2v6.561H9.561l-2.7-2.7,8.2-8.2Z" transform="translate(-3 -3)" fill="currentColor" />
                                                </svg>
                                                <span>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                                            </div>
                                            <div className="features-buttons" onClick={this.handleClearSelection}>
                                                <svg id="delete" xmlns="http://www.w3.org/2000/svg" width="11.274" height="16.156" viewBox="0 0 11.274 16.156">
                                                    <g id="Group_23297" data-name="Group 23297" transform="translate(0)">
                                                        <g id="Group_23296" data-name="Group 23296" transform="translate(0)">
                                                            <path id="Path_11289" data-name="Path 11289" d="M64,95a1.61,1.61,0,0,0,1.611,1.611h6.443A1.61,1.61,0,0,0,73.664,95V85.333H64Z" transform="translate(-63.195 -81.201)" fill="none" stroke="currentColor" stroke-width="1.5" />
                                                            <path id="Path_11290" data-name="Path 11290" d="M51.123.805,50.317,0H46.291l-.805.805H42.667V2.416H53.941V.805Z" transform="translate(-42.667)" fill="currentColor" />
                                                        </g>
                                                    </g>
                                                </svg>
                                                <span>Clear Selection</span>
                                            </div>
                                            {/* <span className="vs-links" onClick={this.handleCollapseAll}>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                                <div className="links-sepration-blue"></div>
                                <Link className="vs-links" onClick={this.handleBackToResult}>Back to All Results</Link>
                                <div className="links-sepration-blue"></div>
                                <Link className="vs-links" onClick={this.handleClearSelection}>Clear Selection</Link> */}
                                        </div>
                                        <div className="links-sepration-blue"></div>
                                        <div className="buttons-container">
                                            <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showSaveModal: true, showPrintModal: false, showEmailModal: false, showDownloadModal: false }) }} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 20.519 20.519">
                                                    <g id="Group_28467" data-name="Group 28467" transform="translate(-3843.3 2941)">
                                                        <g id="Group_28466" data-name="Group 28466" transform="translate(3839.839 -2943.09)">
                                                            <g id="Group_27941" data-name="Group 27941" transform="translate(3.46 4.792)">
                                                                <path id="Path_16659" data-name="Path 16659" d="M20.661,6.256,19.339,4.792,9.515,14.543,5.2,10.234,3.46,11.554l6.054,6.066Z" transform="translate(-3.46 -4.792)" fill="currentColor" />
                                                                <rect id="Rectangle_7915" data-name="Rectangle 7915" width="14.244" height="2.035" transform="translate(1.446 13.619)" fill="currentColor" />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <span>Save</span>
                                            </div>
                                            {/* <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showPrintModal: true, showSaveModal: false, showEmailModal: false, showDownloadModal: false }) }}>
                                                <img src={printBlueIcon} alt="print-icon" width={15} height={15} className="vs-img" />
                                                <img src={printWhiteIcon} alt="save-icon" width={15} height={15} className="vs-img-hov" />
                                                <span>Print</span>
                                            </div> */}
                                            <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showEmailModal: true, showSaveModal: false, showPrintModal: false, showDownloadModal: false }) }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20.519" height="20.519" viewBox="0 0 30.519 30.519">
                                                    <g id="mark_email_read_black_18dp" transform="translate(0.15 0.15)">
                                                        <rect id="Rectangle_7959" data-name="Rectangle 7959" width="20" height="20" transform="translate(-0.15 -0.15)" fill="none" />
                                                        <path id="Path_16756" data-name="Path 16756" d="M13.559,19.688H5.2V9.24l8.363,5.022L22.04,9.24v6.11h2.077V5.508A1.513,1.513,0,0,0,22.609,4H4.508A1.513,1.513,0,0,0,3,5.508V20.592A1.513,1.513,0,0,0,4.508,22.1h9.05Zm9.05-13.317-9.05,4.9L5.2,6.371ZM19.23,23.609l-4.65-4.195,1.071-1.071,3.579,3.124,8.325-8.292,1.056,1.086Z" transform="translate(1.551 2.06)" fill="currentColor" />
                                                    </g>
                                                </svg>
                                                <span>Email</span>
                                            </div>
                                            <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showDownloadModal: true, showSaveModal: false, showPrintModal: false, showEmailModal: false }) }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18.786" height="18.786" viewBox="0 0 18.786 18.786">
                                                    <path id="Path_17574" data-name="Path 17574" d="M19.7,12.393V19.7H5.087V12.393H3V19.7a2.093,2.093,0,0,0,2.087,2.087H19.7A2.093,2.093,0,0,0,21.786,19.7V12.393Zm-6.262.7,2.7-2.693,1.472,1.472L12.393,17.09,7.175,11.871,8.646,10.4l2.7,2.693V3h2.087Z" transform="translate(-3 -3)" fill="currentColor" />
                                                </svg>
                                                <span>Download</span>
                                            </div>
                                        </div>
                                    </div>
                        }
                        {/* <div className="view-selected-top-bottom-container">
                        //     <div className="links-container">
                        //         <div className="features-buttons" onClick={this.handleBackToResult}>
                        //             <img src={backToAllResults} alt="BackToAllResults" className="vs-img" width={15} height={15} />
                        //             <img src={leftArrowWhite} alt="BackToAllResults" className="vs-img-hov" width={15} height={15} />
                        //             <span>Back to All Results</span>
                        //         </div>
                        //         <div className="features-buttons" onClick={this.handleCollapseAll}>
                        //             <img src={collapseAllIcon} alt="collapseAllIcon" className="vs-img" />
                        //             <img src={collapseAllIconWhite} alt="collapseAllIcon" className="vs-img-hov" />
                        //             <span>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                        //         </div>
                        //         <div className="features-buttons" onClick={this.handleClearSelection}>
                        //             <img src={deleteIcon} alt="deleteIcon" className="vs-img" width={11} height={15} />
                        //             <img src={deleteWhite} alt="deleteIcon" className="vs-img-hov" width={11} height={15} />
                        //             <span>Clear Selection</span>
                        //         </div> */}
                        {/* <span className="vs-links" onClick={this.handleCollapseAll}>{this.state.isCollapseAll ? "Expand All" : "Collapse All"}</span>
                        //         <div className="links-sepration-blue"></div>
                        //         <Link className="vs-links" onClick={this.handleBackToResult}>Back to All Results</Link>
                        //         <div className="links-sepration-blue"></div>
                        //         <Link className="vs-links" onClick={this.handleClearSelection}>Clear Selection</Link> */}
                        {/* //     </div>
                        //     <div className="links-sepration-blue"></div>
                        //     <div className="buttons-container">
                        //         <div className="features-buttons" onClick={(e) => { this.setState({ showGSFModal: true, showSaveModal: true, showPrintModal: false, showEmailModal: false, showDownloadModal: false }) }} >
                        //             <img src={saveBlueIcon} alt="save-icon" width={17} height={17} className="vs-img" //onMouseOver={e=>(e.currentTarget.src=saveWhiteIcon)} onMouseOut={e=>(e.currentTarget.src=saveBlueIcon)} />
                        //             <img src={saveWhiteIcon} alt="save-icon" width={17} height={17} className="vs-img-hov" />
                        //             <span>Save</span>
                        //         </div>
                        //         <div className="features-buttons" //onClick={(e) => { this.setState({ showGSFModal: true, showPrintModal: true, showSaveModal: false, showEmailModal: false, showDownloadModal: false }) }} >
                        //             <img src={printBlueIcon} alt="print-icon" width={15} height={15} className="vs-img" />
                        //             <img src={printWhiteIcon} alt="save-icon" width={15} height={15} className="vs-img-hov" />
                        //             <span>Print</span>
                        //         </div>
                        //         <div className="features-buttons" //onClick={(e) => { this.setState({ showGSFModal: true, showEmailModal: true, showSaveModal: false, showPrintModal: false, showDownloadModal: false }) }}>
                        //             <img src={emailBlueIcon} alt="email-icon" width={20} height={20} className="vs-img" />
                        //             <img src={emailWhiteIcon} alt="save-icon" width={20} height={20} className="vs-img-hov" />
                        //             <span>Email</span>
                        //         </div>
                        //         <div className="features-buttons" //</>onClick={(e) => { this.setState({ showGSFModal: true, showDownloadModal: true, showSaveModal: false, showPrintModal: false, showEmailModal: false }) }}>
                        //             <img src={downloadBlueIcon} alt="download-icon" width={18} height={18} className="vs-img" />
                        //             <img src={downloadWhiteIcon} alt="save-icon" width={18} height={18} className="vs-img-hov" />
                        //             <span>Download</span>
                        //         </div>
                        //     </div>
                         </div> */}
                        <div className="view-selected-wrapper">
                            {this.selectedResults(this.state.selectedCitation, this.state.itemTeaser, this.state.documentIndex)}
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                            </p>
                        </div>
                        <div style={{ margin: "0 1.5%" }}>
                            <Footer customWidth={this.state.width} customHeight={this.state.height} />
                        </div>
                        {
                            this.state.showGSFModal &&
                            <MIAsRefGlobalSearchFeaturePopUpModal showModal={this.state.showGSFModal} handleClose={(status) => { this.setState({ showGSFModal: status }) }} showSaveModal={this.state.showSaveModal} showPrintModal={this.state.showPrintModal} showEmailModal={this.state.showEmailModal} showDownloadModal={this.state.showDownloadModal} selectedResults={this.state.selectedResults} customWidth={this.state.width} customHeight={this.state.height} documentsUrl={this.documentsUrl} markedDocumentsUrl={this.markedDocumentsUrl} />
                        }
                    </>
                        :
                        <div style={{ textAlign: "center", padding: "10%" }}>
                            <img src={imsLoader} alt="Loading Data" style={{ width: "20%" }} />
                        </div>
                    }
                </ErrorBoundary>
            </div>

        )
    }
}
export default ViewSelectedResultsMIAsReferences;